export default __webpack_public_path__ + "static/doodle-footer-c2f180fea1c3603441844219bebfaadc.gif";